module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@3x-2a911c9a47af3bc26fb310071f4bcfad.png";